import { apiRequest } from '@/api/helpers/apiRequest';
import {
  CreateRoleTemplateRequestSchema,
  CreateRoleTemplateResponseSchema,
} from 'schemas';
import { handleApiError } from '@/api/helpers/handleApiError';

export const createRoleTemplate = async (data: {
  title: string;
  description: string;
}) => {
  try {
    // Validate request data
    const validatedData = CreateRoleTemplateRequestSchema.parse(data);

    return await apiRequest(
      'POST',
      '/api/role-templates',
      validatedData,
      CreateRoleTemplateResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
